import React, {Suspense} from "react";
import {Redirect, Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../_metronic/layout";
import {DashboardPage} from "./pages/DashboardPage";
import RolesList from "./pages/roles/roles-list";
import PermissionsList from "./pages/permissions/permissions-list";
import UsersList from "./pages/users/users-list";
import ConciergesList from "./pages/concierges/concierges-list";
import Hospitalization from "./pages/hospital/hospitalization/hospitalization";
import HospitalizationCreate from "./pages/hospital/hospitalization/hospitalization-create";
import ControlDesk from "./pages/insurance/control-desk/control-desk";
import ControlDeskDetails from "./pages/insurance/control-desk/control-desk-details";
import MedicalOpinion from "./pages/insurance/medical-opinion/medical-opinion";
import MedicalOpinionDetails from "./pages/insurance/medical-opinion/medical-opinion-details";
import Tracing from "./pages/hospital/tracing/tracing";
import TracingDetails from "./pages/hospital/tracing/tracing-details";
import MedicalInformation from "./pages/hospital/medic-information/medical-information";
import MedicalInformationDetails from "./pages/hospital/medic-information/medical-information-details";
import CostControl from "./pages/insurance/cost-control/cost-control";
import CostControlDetails from "./pages/insurance/cost-control/cost-control-details";
import StorePatient from "./pages/hospital/store-patient/store-patient";
import StorePatientDetails from "./pages/hospital/store-patient/store-patient-details";
import Reconsideration from "./pages/insurance/reconsideration/reconsideration";
import ReconsiderationDetails from "./pages/insurance/reconsideration/reconsideration-details";
import GeneralConsult from "./pages/hospital/general-consult/general-consult";
import GeneralConsultDetails from "./pages/hospital/general-consult/general-consult-details";
import AlwaysWithYou from "./pages/insurance/always-with-you/always-with-you";
import AlwaysWithYouDetails from "./pages/insurance/always-with-you/always-with-you-details";
import UpdateProcedure from "./pages/hospital/update-procedure/update-procedure";
import UpdateProcedureDetails from "./pages/hospital/update-procedure/update-procedure-details";
import DoctorsList from "./pages/doctors/doctors-list";
import NursesList from "./pages/nurses/nurses-list";
import HospitalsList from "./pages/hospitals/hospitals-list";
import { ControlBoard } from "./pages/dashboard/control-panel";
import { ControlBoardDictum } from "./pages/dashboard/control-board-dictum";
import { ControlBoardCostControl } from "./pages/dashboard/control-board-cost-control";
import Tab from "./pages/insurance/tab/tab";
import TabDetails from "./pages/insurance/tab/tab-details";
import Requests from "./pages/insurance/requests/requests";
import CompletedCases from "./pages/insurance/completed-cases/completed-cases";
import CompletedCasesDetails from "./pages/insurance/completed-cases/completed-cases-details";
import CompletedCasesHospital from "./pages/hospital/completed-cases/completed-cases";
import CompletedCasesDetailsHospital from "./pages/hospital/completed-cases/completed-cases-details";
import CasesCanceled from "./pages/insurance/cases-canceled/cases-canceled";
import CasesCanceledDetails from "./pages/insurance/cases-canceled/cases-canceled-details";
import OutHospitalFollowUp from "./pages/hospital/out-hospital-follow-up/out-hospital-follow-up";
import OutHospitalFollowUpDetails from "./pages/hospital/out-hospital-follow-up/out-hospital-follow-up-details";
import ScheduledSurgeries from "@pages/hospital/scheduled-surgeries/scheduled-surgeries";
import Programmings from "./pages/insurance/programmings/programmings";
import MedicSelfRegistrations from "./pages/insurance/medic-self-registrations/medic-self-registrations";
import MedicSelfRegistrationsDetails from "./pages/insurance/medic-self-registrations/medic-self-registration-details";
import HospitalSupervision from "@pages/insurance/hospital-supervision/hostital-supervision";
import HospitalSupervisionDetails from "@pages/insurance/hospital-supervision/hospital-supervision-details";
import { AxaDisclaimerBanner } from "@components/shared/axa-disclaimer-banner";

export default function BasePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <AxaDisclaimerBanner/>
            <Switch>
                {
                    /* Redirect from root URL to /dashboard. */
                    <Redirect exact from="/" to="/dashboard"/>
                }
                <ContentRoute path="/dashboard" component={DashboardPage}/>
                
                <ContentRoute path="/roles" permission="Roles" component={RolesList}/>
                
                <ContentRoute path="/privilegios" permission="Privilegios" component={PermissionsList}/>
                
                <ContentRoute path="/usuarios" permission="Usuarios" component={UsersList}/>

                <ContentRoute path="/doctores" permission="Doctores" component={DoctorsList}/>

                <ContentRoute path="/enfermeras" permission="Enfermeras" component={NursesList}/>

                <ContentRoute path="/hospitales" permission="Hospitales" component={HospitalsList}/>

                <ContentRoute path="/concierges" permission="Concierges" component={ConciergesList}/>

                <ContentRoute path="/ingreso_hospitalario" permission="Ingreso Hospitalario" component={HospitalizationCreate}/>
                <ContentRoute path="/ingreso_hospitalario_detalles/:slug" permission="Ingreso Hospitalario" component={Hospitalization}/>

                <ContentRoute path="/seguimiento" permission="Seguimiento" component={Tracing}/>
                <ContentRoute path="/seguimiento_detalles/:slug" permission="Seguimiento" component={TracingDetails}/>

                <ContentRoute path="/mesa_control" permission="Mesa de Control" component={ControlDesk}/>
                <ContentRoute path="/mesa_control_detalles/:slug" permission="Mesa de Control" component={ControlDeskDetails}/>

                <ContentRoute path="/dictamen_medico" permission="Dictamen Medico" component={MedicalOpinion}/>
                <ContentRoute path="/dictamen_medico_detalles/:slug" permission="Dictamen Medico" component={MedicalOpinionDetails}/>

                <ContentRoute path="/informacion_medica" permission="Informacion Medica" component={MedicalInformation}/>
                <ContentRoute path="/informacion_medica_detalles/:slug" permission="Informacion Medica" component={MedicalInformationDetails}/>

                <ContentRoute path="/control_costos" permission="Control de Costos" component={CostControl}/>
                <ContentRoute path="/control_costos_detalles/:slug" permission="Control de Costos" component={CostControlDetails}/>

                <ContentRoute path="/alta_paciente" permission="Alta Paciente" component={StorePatient}/>
                <ContentRoute path="/alta_paciente_detalles/:slug" permission="Alta Paciente" component={StorePatientDetails}/>

                <ContentRoute path="/reconsideraciones" permission="Reconsideraciones" component={Reconsideration}/>
                <ContentRoute path="/reconsideraciones_detalles/:slug" permission="Reconsideraciones" component={ReconsiderationDetails}/>

                <ContentRoute path="/consulta_general" permission="Consulta General" component={GeneralConsult}/>
                <ContentRoute path="/consulta_general_detalles/:slug" permission ="Consulta General" component={GeneralConsultDetails}/>

                <ContentRoute path="/actualizacion_tramite" permission="Actualizacion de Tramite" component={UpdateProcedure}/>
                <ContentRoute path="/actualizacion_tramite_detalles/:slug" permission ="Actualizacion de Tramite" component={UpdateProcedureDetails}/>

                <ContentRoute path="/24_7_contigo" permission="24/7 Contigo" component={AlwaysWithYou}/>
                <ContentRoute path="/24_7_contigo_detalles/:slug" permission="24/7 Contigo" component={AlwaysWithYouDetails}/>

                <ContentRoute path="/tablero_control" permission="Tablero de Control" component={ControlBoard}/>
                <ContentRoute path="/tablero_dictamen" permission="Tablero de Dictamen" component={ControlBoardDictum}/>
                <ContentRoute path="/tablero_control_costos" permission="Tablero de Control de Costos" component={ControlBoardCostControl}/>

                <ContentRoute path="/dictamen_extemporaneo" permission="Dictamen Extemporaneo" component={Tab}/>
                <ContentRoute path="/dictamen_extemporaneo_detalles/:slug" permission="Dictamen Extemporaneo" component={TabDetails}/>

                <ContentRoute path="/solicitudes" permission="Solicitudes" component={Requests}/>

                <ContentRoute path="/casos_finalizados" permission="Casos Finalizados" component={CompletedCases}/>
                <ContentRoute path="/casos_finalizados_detalles/:slug" permission="Casos Finalizados" component={CompletedCasesDetails}/>
                <ContentRoute path="/cancelaciones" permission="Cancelaciones" component={CasesCanceled}/>
                <ContentRoute path="/cancelaciones_detalles/:slug" permission="Cancelaciones" component={CasesCanceledDetails}/>

                <ContentRoute path="/casos_finalizados_hospital" permission="Casos Finalizados" component={CompletedCasesHospital}/>
                <ContentRoute path="/casos_finalizados_hospital_detalles/:slug" permission="Casos Finalizados" component={CompletedCasesDetailsHospital}/>

                <ContentRoute path="/seguimiento_extrahospitalario" permission="Casos Finalizados" component={OutHospitalFollowUp}/>
                <ContentRoute path="/seguimiento_extrahospitalario_detalles/:slug" permission="Casos Finalizados" component={OutHospitalFollowUpDetails}/>

                <ContentRoute path="/cirugias_programadas" permission="Cirugias Programadas" component={ScheduledSurgeries}/>

                <ContentRoute path="/programaciones" permission="Programaciones" component={Programmings}/>

                <ContentRoute path="/solicitudes_registros_medicos" permission="Solicitudes Registros Medicos" component={MedicSelfRegistrations}/>
                <ContentRoute path="/solicitudes_registros_medicos_detalles/:slug" permission="Solicitudes Registros Medicos" component={MedicSelfRegistrationsDetails}/>

                <ContentRoute path="/supervision_hospitalaria" permission="Supervision Hospitalaria" component={HospitalSupervision}/>
                <ContentRoute path="/supervision_hospitalaria_detalles/:slug" permission="Supervision Hospitalaria" component={HospitalSupervisionDetails}/>

                <Redirect to="/error/error-v1"/>
            </Switch>
        </Suspense>
    );
}
